import React, { Component } from "react";
import axios from 'axios';
const API_PATH = 'https://an-intl.co/api/revoomail.php';


// const required = (value) => (value ? undefined : "Required");
export default class Contactform extends Component {

    constructor(props) {
        super(props);
        this.state = {
          fname: '',
          lname: '',
          email: '',
          phone: '',
          message: ''
        }
      }
      handleFormSubmit = e => {
        e.preventDefault();
        axios({
          method: 'post',
          url: `${API_PATH}`,
          headers: { 'Content-Type': 'application/json' },
          data: this.state
        })
          .then(result => {
            this.setState({
              mailSent: result.data.sent
            })
            alert('Thank You. We will contact you shortly');
            window.location = "/contact-us"
          })
          .catch(error => this.setState({ error: error.message }));
          
          
      };
    render(){
        
        return(
            <>
            <div className='form-head'>
                <h1>Get In Touch</h1>
                <p>Fill The Form Below</p>
            </div>
            <center><hr className='trail-hr' width="300px;" size="10" align="center"/></center>
            <div className='trail-form'>
                <div className='container'>
                <form onSubmit={e => this.handleFormSubmit(e)} className="rkp-test">
                    <div className='row'>
                        <div className='col-lg-6'>
                            <input type={'text'} id="fname" className='rkp-control' placeholder='First Name'  value={this.state.fname}
    onChange={e => this.setState({ fname: e.target.value })} ></input>
                        </div>
                        <div className='col-lg-6'>
                            <input type={'text'} id="lname" className='rkp-control' placeholder='Last Name (Optional)'  value={this.state.lname}
    onChange={e => this.setState({ lname: e.target.value })} ></input>
                        </div>
                        <div className='col-lg-6'>
                            <input type={'text'} id="email" className='rkp-control' placeholder='E-mail' value={this.state.email}
    onChange={e => this.setState({ email: e.target.value })} ></input>
                        </div>
                        <br/>
                        <div className='col-lg-6'>
                            <input type={'number'} id="phone" className='form-control' placeholder='Phone Number' value={this.state.phone}
    onChange={e => this.setState({ phone: e.target.value })} ></input>
                        </div>
                        <div className='col-lg-12'>
                        <textarea className='form-control' rows="7" id="message" cols="153" placeholder='Your Message'  value={this.state.message}
    onChange={e => this.setState({ message: e.target.value })} > 
                        </textarea>
                            
                        </div>
                        
                    </div>
                    <div className='start-button'>
                        <button type='submit' className='btn' >Submit<span>&nbsp;&nbsp;&nbsp;<i className='fa fa-angle-right'></i></span></button>
                    </div>
                    
                </form>
                </div>
            </div>
            </>
        )
    }
    
}